import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { BrandImage } from './components/BrandImage';
import { useSkinAnalyzerBrandData } from './hooks/useSkinAnalyzerBrandData';
import { useInitSkinAnalyzer } from './lib/hooks/useInitSkinAnalyzer';
import { openSkinAnalyzer } from './lib/skinAnalyzerScripts';
import { trackViewOrSelectPromotion } from './lib/tracking';
import { SkinAnalyserWrapper } from './styled';

const SkinAnalyser = () => {
  const { inView, ref } = useInView({
    triggerOnce: true,
  });

  const brand = useSkinAnalyzerBrandData();

  useInitSkinAnalyzer({
    inView,
    brand,
  });

  const onOpenSkinAnalyzer = () => {
    trackViewOrSelectPromotion(brand?.brandName, 'select_promotion');
    openSkinAnalyzer();
  };

  return (
    <SkinAnalyserWrapper ref={ref} onClick={onOpenSkinAnalyzer}>
      <BrandImage />
    </SkinAnalyserWrapper>
  );
};

export default SkinAnalyser;
